import { css } from '@emotion/react';
import { color } from '@uniquegood/realworld-studio-design';

interface AiCreateButtonProps {
  creditValue: number;
  width?: string | number;
  height?: string | number;
  onClick?: () => void;
}

function AiCreateButton({ creditValue, width, height, onClick }: AiCreateButtonProps) {
  return (
    <button css={buttonStyle(width, height)} onClick={onClick} type="button">
      <div css={contentStyle}>
        <span css={textStyle}>AI로 만들기</span>
        <div css={creditContainerStyle}>
          <img src="/assets/icons/stars.svg" alt="stars" css={iconStyle} />
          <span css={creditStyle}>{creditValue}</span>
        </div>
      </div>
    </button>
  );
}

const buttonStyle = (width?: string | number, height?: string | number) => css`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  position: relative;
  border-radius: 8px;
  background: linear-gradient(94deg, #4a41ff 0%, #22f8e2 100%);
  border: none;
  cursor: pointer;
  width: ${width || 'auto'};
  height: ${height || 'auto'};
  box-sizing: border-box;

  &:focus-visible {
    outline: 4px solid ${color.focused_default};
  }
`;

const creditContainerStyle = css`
  display: flex;
  align-items: center;
`;

const contentStyle = css`
  display: flex;
  align-items: center;
  position: relative;
  gap: 4px;
  flex-shrink: 0;
`;

const textStyle = css`
  color: #ffffff;
  text-align: center;
  font-feature-settings: 'liga' off, 'clig' off;
  text-shadow: rgba(249, 240, 255, 0.4) 0px 0px 4px;
  font-family: 'Pretendard', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  white-space: nowrap;
`;

const iconStyle = css`
  width: 16px;
  height: 16px;
  flex-shrink: 0;
`;

const creditStyle = css`
  font-family: 'Pretendard', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: #ffffff;
  text-align: center;
  white-space: nowrap;
`;

export default AiCreateButton;
